export default __webpack_public_path__ + "static/media/img (2).5916a4e8.jpg";